class _httpPendingRequestTracker {
    _requests = [];

    isRequestPending(request) {
        const requestString = JSON.stringify(request);
        const search = this._requests.find(x => x === requestString);
        if (search) {
            return true;
        }
        else {
            this._requests.push(requestString);
            return false;
        }
    }
    requestFinished(request) {
        const requestString = JSON.stringify(request);
        const search = this._requests.find(x => x === requestString);
        if (search)
            this._requests.splice(this._requests.indexOf(search), 1);
    }
}

const HttpPendingRequestTracker = new _httpPendingRequestTracker();
export default HttpPendingRequestTracker;


// WEBPACK FOOTER //
// ./src/boot/httpPendingRequestTracker.js